import { Component, inject, input, output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AboutDialogComponent } from '../about/about-dialog.component';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'sphere-shell-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    imports: [MatIconButton, MatMenuTrigger, MatTooltip, MatIcon, MatMenu, MatMenuItem, RouterLink]
})
export class UserMenuComponent {
    private dialog = inject(MatDialog);

    public readonly username = input.required<string>();
    public readonly canResetPassword = input(false);

    public readonly logout = output();
    public readonly openResetPasswordDialog = output();
    public readonly openSettingsDialog = output();

    public resetPassword(): void {
        this.openResetPasswordDialog.emit();
    }

    public openAbout() {
        this.dialog.open(AboutDialogComponent, <MatDialogConfig>{});
    }

    public openGlobalSettings() {
        this.openSettingsDialog.emit();
        //this.settingsDialog.openSettings();
    }
}
